module.exports = __webpack_public_path__ + "static/media/logo-external.c67d47c9.png";